import React, { useEffect, useState } from 'react'
import PointSpreadLoading from 'react-loadingg/lib/PointSpreadLoading'
import { getAllfoodDiscountApi} from '../../Api/ClientServices'
import More from '../../Component/More/More'
import Style from './MoreDiscountFood.module.css'
import { errorToast } from '../../Toast/Toast'

const MoreDiscountFood = () => {
    const[moreDiscount,setMoreDiscount]=useState()
    useEffect(()=>{
        getDiscount()
    },[]) 
 
    const getDiscount=async()=>{
        getAllfoodDiscountApi((succ,res)=>{
            if(succ){
              if(res.status===1){
                errorToast("مشکلی پیش آمده است")
              }else{
                setMoreDiscount(res.products)
              }
            }else{
              console.error(res)
            }
          })
       
    }

    return (
        <div className={Style.pageHolder}>
            {moreDiscount===undefined ? 
            <div>
                 <PointSpreadLoading color={'#ab0c59'} size={"small"} />
            </div>
            :
            <More data={moreDiscount} title={"تخفیف های رستوران"} headerText={"در بَرِست از تخفیف ها لذت ببرید"} category={getDiscount}/>
            }
        </div>
    )
}

export default MoreDiscountFood
